export type Product = {
    id: string;
    name: string;
    description: string;
    logo: string;
    coverPhoto: string;
    color: string;
};

export const products: Product[] = [
    {
        id: "1",
        name: "Eissa Docs",
        coverPhoto: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        logo: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        description: `Eissa Docs is a secure document management app that allows users to store, organize, and share files safely. It features real-time collaboration and cloud syncing for seamless access across devices.`,
        color: "rgb(66, 133, 244)",
    },
    {
        id: "2",
        name: "Eissa Meet",
        coverPhoto: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        logo: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        description: `Eissa Meet is a video conferencing platform designed for high-quality virtual meetings. It supports screen sharing, chat, and scheduling to enhance collaboration for teams and individuals.`,
        color: "rgb(155, 89, 182)",
    },
    {
        id: "3",
        name: "Eissa Message",
        coverPhoto: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        logo: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        description: `Eissa Message is a messaging app that ensures fast and secure communication. It supports text, media, and group messaging with end-to-end encryption for privacy.`,
        color: "rgb(46, 204, 113)",
    },
    {
        id: "4",
        name: "Eissa Calendar",
        coverPhoto: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        logo: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        description: `Eissa Calendar helps you organize your schedule efficiently. It features event reminders, recurring tasks, and seamless integration with other Eissa apps to keep you on track.`,
        color: "rgb(231, 76, 60)",
    },
    {
        id: "5",
        name: "Eissa Draw",
        coverPhoto: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        logo: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        description: `Eissa Draw is a digital drawing app for artists and designers. It offers brushes, layers, and export options to create professional-quality artwork with ease.`,
        color: "rgb(230, 126, 34)",
    },
    {
        id: "6",
        name: "Eissa Keep",
        coverPhoto: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        logo: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
        description: `Eissa Keep is a note-taking app that allows users to capture ideas, make checklists, and organize notes efficiently. Syncs across devices for easy access anytime.`,
        color: "rgb(244, 180, 0)",
    },
];

